(function () {
  // Idempotent: this script may be printed twice on the cart page
  // (once for the drawer, once for the page column).
  if (window.YPShippingProtectionLoaded) return;
  window.YPShippingProtectionLoaded = true;

  var PROP = '_shipping_protection';
  var OPTOUT_KEY = 'yp_sp_optout';

  function routes() {
    return (window.theme && theme.routes) || {};
  }

  function getCart() {
    return fetch(routes().cart || '/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); });
  }

  function findProtectionItem(cart, variantId) {
    return cart.items.filter(function (item) {
      return item.variant_id === variantId || (item.properties && item.properties[PROP]);
    })[0];
  }

  // Any item in the cart that ships and isn't the protection line. Services
  // such as the $50 lash consultation don't ship, so a cart holding only those
  // never gets protection (Shirley, 30 Sep 2026). $0 lines (the free Mystery
  // Gift) don't count either: they only ride along with a paid parcel.
  function hasOtherItems(cart, variantId) {
    return cart.items.some(function (item) {
      return item.variant_id !== variantId && !(item.properties && item.properties[PROP]) &&
        item.requires_shipping !== false && item.final_line_price > 0;
    });
  }

  function optedOut() {
    try { return localStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try {
      if (v) localStorage.setItem(OPTOUT_KEY, '1');
      else localStorage.removeItem(OPTOUT_KEY);
    } catch (e) {}
  }

  function ShippingProtection(el) {
    this.el = el;
    this.variantId = parseInt(el.getAttribute('data-variant-id'), 10);
    this.input = el.querySelector('[data-sp-toggle]');
    this.busy = false;
    this.lastPresent = null;
    // Only one instance owns auto-adding, to avoid a double-add race when the
    // drawer and the cart-page widget are both on the page. The drawer widget
    // exists on every page, so it's the natural owner.
    this.isOwner = !!el.closest('.cart__drawer-form');

    if (!this.variantId || !this.input) return;

    this.input.addEventListener('change', this.onToggle.bind(this));
    this.sync();

    document.addEventListener('cart:updated', this.sync.bind(this));
    document.addEventListener('ajaxProduct:added', this.sync.bind(this));
  }

  ShippingProtection.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.input.disabled = busy;
    this.el.classList.toggle('is-busy', busy);
  };

  ShippingProtection.prototype.setChecked = function (checked) {
    // Setting .checked programmatically does not fire a change event.
    if (this.input.checked !== checked) this.input.checked = checked;
  };

  // Reflect the cart's real state onto the toggle, and — because protection
  // defaults ON — auto-add it when the cart has products and the shopper
  // hasn't opted out.
  ShippingProtection.prototype.sync = function () {
    if (this.busy) return;
    var self = this;
    getCart().then(function (cart) {
      var present = !!findProtectionItem(cart, self.variantId);
      var others = hasOtherItems(cart, self.variantId);

      // Nothing that ships (empty, or only a service like the consultation):
      // treat as a fresh start, hide the toggle and drop any protection line.
      self.el.style.display = others ? '' : 'none';
      if (!others) {
        setOptOut(false);
        self.lastPresent = false;
        self.setChecked(false);
        var stray = findProtectionItem(cart, self.variantId);
        if (stray && self.isOwner && !window.__spAutoAdding) {
          window.__spAutoAdding = true;
          self.setBusy(true);
          self.remove(stray.key)
            .catch(function () {})
            .then(function () {
              self.setBusy(false);
              window.__spAutoAdding = false;
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
            });
        }
        return;
      }

      if (present) {
        self.lastPresent = true;
        self.setChecked(true);
        return;
      }

      // Protection absent while the cart has products. If it was present a
      // moment ago, the shopper just removed it — remember that choice.
      if (self.lastPresent === true) setOptOut(true);
      self.lastPresent = false;
      self.setChecked(false);

      // Default ON: add it back unless the shopper opted out.
      if (!optedOut() && self.isOwner && !window.__spAutoAdding) {
        window.__spAutoAdding = true;
        self.setBusy(true);
        self.add()
          .then(function () {
            self.lastPresent = true;
            self.setChecked(true);
          })
          .catch(function () {})
          .then(function () {
            self.setBusy(false);
            window.__spAutoAdding = false;
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          });
      }
    }).catch(function () {});
  };

  ShippingProtection.prototype.onToggle = function () {
    var self = this;
    var wantOn = this.input.checked;
    // Turning it off is an explicit opt-out; turning it on opts back in.
    setOptOut(!wantOn);
    this.setBusy(true);

    getCart()
      .then(function (cart) {
        var item = findProtectionItem(cart, self.variantId);
        if (wantOn && !item) return self.add();
        if (!wantOn && item) return self.remove(item.key);
        return null;
      })
      .then(function () {
        self.lastPresent = wantOn;
        self.setBusy(false);
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        self.setBusy(false);
        self.sync();
      });
  };

  ShippingProtection.prototype.add = function () {
    var properties = {};
    properties[PROP] = 'true';
    return fetch(routes().cartAdd || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: this.variantId, quantity: 1, properties: properties })
    });
  };

  ShippingProtection.prototype.remove = function (key) {
    return fetch(routes().cartChange || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  };

  function init() {
    document.querySelectorAll('[data-shipping-protection]').forEach(function (el) {
      if (el.spInstance) return;
      el.spInstance = new ShippingProtection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The drawer form is re-rendered on cart changes; re-bind any fresh nodes.
  document.addEventListener('cart:updated', init);
  document.addEventListener('shopify:section:load', init);
})();
